import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { euro } from "../lib/format";
import SelectableCard, { useCardColors } from "./SelectableCard";

export default function PackageCard({ p, selected, onSelect }) {
  const c = useCardColors();
  const rec = !!p.recommended;
  return (
    <SelectableCard
      id={`package-${p.id}`}
      testid={`package-card-${p.id}`}
      selected={selected}
      onSelect={onSelect}
      recommended={rec}
      className={`flex h-full scroll-mt-24 flex-col px-7 py-9 sm:px-8 sm:py-10 ${rec ? "max-md:order-first" : ""}`}
    >
      {rec && (
        <span
          data-testid={`package-recommended-badge-${p.id}`}
          className="mb-4 inline-flex w-fit items-center rounded-full px-3 py-1 font-sans text-[10px] font-bold uppercase tracking-[0.2em] text-white"
          style={{ background: c.heading }}
        >
          Recommended
        </span>
      )}
      <h3 className="font-sans text-[26px] font-extrabold leading-[1.1] tracking-tight" style={{ color: c.heading }}>
        {p.name}
      </h3>
      <p className="mt-4 text-base leading-relaxed" style={{ color: c.body }}>{p.summary}</p>
      <p className="mt-7 flex flex-wrap items-baseline gap-x-3" data-testid={`package-price-${p.id}`}>
        <span className="font-sans text-[44px] font-extrabold tracking-tight" style={{ color: c.heading }}>{euro(p.priceFrom)}</span>
        {p.priceLabel && (
          <span className="font-mono text-xs uppercase tracking-[0.22em]" style={{ color: c.body, opacity: 0.7 }}>{p.priceLabel}</span>
        )}
      </p>
      <ul className="mt-8 flex-1 space-y-3.5">
        {(p.includes || []).map((inc) => (
          <li key={inc} className="flex gap-3 text-[15px] leading-snug" style={{ color: c.body }}>
            <Check aria-hidden="true" strokeWidth={2.5} className="mt-0.5 h-5 w-5 shrink-0" style={{ color: c.check }} />
            {inc}
          </li>
        ))}
      </ul>
      {p.footnote && (
        <p className="mt-8 font-mono text-[11px] uppercase leading-relaxed tracking-[0.16em]" style={{ color: c.body, opacity: 0.75 }}>
          {p.footnote}
        </p>
      )}
      <Link
        to={`/?service=${encodeURIComponent(p.name)}#contact`}
        data-testid={`package-discuss-${p.id}`}
        className={`mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-colors duration-200 ${
          rec ? "text-white hover:bg-ink" : "border bg-white hover:text-white"
        }`}
        style={rec ? { background: c.heading } : { borderColor: c.heading, color: c.heading }}
        onMouseEnter={(e) => { if (!rec) e.currentTarget.style.background = c.heading; }}
        onMouseLeave={(e) => { if (!rec) e.currentTarget.style.background = "#ffffff"; }}
      >
        {p.cta} <span aria-hidden="true">→</span>
      </Link>
    </SelectableCard>
  );
}
